import React, { useState, forwardRef } from "react";
import moment from 'moment';
import Loading from "../Loading";
import SessionManager from "../../routes/SessionManager";
import $ from "jquery";

function AdvanceWorkHours(props, refs) {

  var sessionMgr = new SessionManager();
  let user = sessionMgr.readCookie("user");

  const [isHighlighted, setIsHighlighted] = useState();
  const [isMouseDown, setIsMouseDown] = useState();

  const weekdays = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'];
  let workschedule = user.site_selected.site_config.work_hours.work_schedule;
  if (!workschedule) {
    workschedule = {};
    for (let w of weekdays)
      workschedule[w] = Array(48).fill(0);
  } else {
    if (workschedule['monday'].length === 24) { // Backward compat for 24 len array.
      for (let w of weekdays) {
        let tmp = JSON.parse(JSON.stringify(workschedule[w]));
        workschedule[w] = Array(48).fill(0);
        for (let i = 0; i < tmp.length; i++)
          if (tmp[i] === 1) {
            workschedule[w][(2 * i)] = 1;
            workschedule[w][(2 * i) + 1] = 1;
          }
      }
    }
  }

  const [work_schedule, setWorkSchedule] = useState(workschedule);

  var m1 = moment().startOf('day');
  let hours = [];
  while (hours.length < 48) {
    hours.push(m1.format('h:mmA'));
    m1 = m1.add(30, 'minutes');
  }

  let siteComponentRef = props.site_component;
  let loading = '';

  const isChanged = () => {
    let isModified = false;
    let work_hours = { ...user.site_selected.site_config.work_hours };
    work_hours.extended_enabled = props.extended_enabled;
    work_hours.work_schedule = work_schedule;
    siteComponentRef.user.site_selected.site_config.work_hours = work_hours;
    siteComponentRef.isWorkHoursObjectModified();
    return isModified;
  };

  const resetAdvancedWorkHours = () => {
    let userPrev = sessionMgr.readCookie("user");
    let work_schedule = {};
    if (userPrev.site_selected.site_config.work_hours.work_schedule) {
      work_schedule = userPrev.site_selected.site_config.work_hours.work_schedule;
    }
    setWorkSchedule(work_schedule);
    isChanged();
  }

  const onSelected = (day, hr) => {
    if (props.view_only)
      return;

    var workschedule = { ...work_schedule };
    var days = day.toLowerCase();
    var dayData = workschedule[days] ? workschedule[days] : Array(48).fill(0);
    dayData[hours.indexOf(hr)] = dayData[hours.indexOf(hr)] === 1 ? 0 : 1;
    workschedule[days] = dayData;
    setWorkSchedule(workschedule);
    isChanged();
  };

  React.useImperativeHandle(refs, () => ({
    resetAdvancedWorkHours
  }));

  return (
    <React.Fragment>
      {loading && (<div> <Loading> Saving Advanced Work Hours Information ...</Loading> </div>)}

      {!loading && (
        <React.Fragment>
          <div
            style={{ overflowX: "auto" }}
            onMouseUp={(e) => {
              e.preventDefault();
              setIsMouseDown(false);
            }}
          >
            <table className="adv-work-hrs">
              <tbody>
                <tr>
                  <th></th>
                  {hours.map((hr, index) => (<th width='100'
                    height='20' key={index} > {hr} </th>))}
                </tr>
                {weekdays.map((day, index) => (
                  <>
                    <tr><th colSpan="49"></th></tr>
                    <tr key={index} >
                      <th key={index} >{day}</th>
                      {hours.map((hr, i) => (
                        <td
                          width='100'
                          height='20'
                          key={i}
                          onMouseDown={(e) => {
                            if (props.view_only)
                              return;
                            e.preventDefault();
                            setIsMouseDown(true);
                            $(e.currentTarget).toggleClass("highlighted");
                            setIsHighlighted($(e.currentTarget).hasClass("highlighted"));
                            onSelected(day, hr);
                            return false;
                          }}
                          onMouseOver={(e) => {
                            e.preventDefault();
                            if (isMouseDown) {
                              $(e.currentTarget).toggleClass("highlighted", isHighlighted);
                              onSelected(day, hr);
                            }
                          }}
                          onMouseUp={(e) => {
                            e.preventDefault();
                            setIsMouseDown(false);
                          }}
                          className={
                            work_schedule[day.toLowerCase()] &&
                              work_schedule[day.toLocaleLowerCase()][hours.indexOf(hr)] === 1 ? "highlighted" : ""
                          }
                        >
                        </td>
                      ))}
                    </tr>
                  </>
                ))}
              </tbody>
            </table>
          </div>
        </React.Fragment>
      )}
    </React.Fragment>
  );

}

export default forwardRef(AdvanceWorkHours);
